var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.558,
    height: 7.824,
    viewBox: "0 0 13.558 7.824",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(13.558) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M.753,2.448l6.72-.738A1.108,1.108,0,0,0,8.4.766.655.655,0,0,0,7.657.005L.937.743a1.108,1.108,0,0,0-.932.945A.655.655,0,0,0,.753,2.448Z",
    transform: "translate(0 11.764) rotate(-43)",
    fill: "#17214d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M.937,1.711l6.72.738A.655.655,0,0,0,8.4,1.688h0A1.108,1.108,0,0,0,7.472.743L.753.005A.655.655,0,0,0,.005.766h0A1.108,1.108,0,0,0,.937,1.711Z",
    transform: "translate(1.673 0) rotate(43)",
    fill: "#17214d"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy41NTgiIGhlaWdodD0iNy44MjQiIHZpZXdCb3g9IjAgMCAxMy41NTggNy44MjQiPgogIDxnIGlkPSJhcnJvdyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMuNTU4KSByb3RhdGUoOTApIj4KICAgIDxwYXRoIGlkPSJQYXRoXzUzIiBkYXRhLW5hbWU9IlBhdGggNTMiIGQ9Ik0uNzUzLDIuNDQ4bDYuNzItLjczOEExLjEwOCwxLjEwOCwwLDAsMCw4LjQuNzY2LjY1NS42NTUsMCwwLDAsNy42NTcuMDA1TC45MzcuNzQzYTEuMTA4LDEuMTA4LDAsMCwwLS45MzIuOTQ1QS42NTUuNjU1LDAsMCwwLC43NTMsMi40NDhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDExLjc2NCkgcm90YXRlKC00MykiIGZpbGw9IiMxNzIxNGQiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzUyIiBkYXRhLW5hbWU9IlBhdGggNTIiIGQ9Ik0uOTM3LDEuNzExbDYuNzIuNzM4QS42NTUuNjU1LDAsMCwwLDguNCwxLjY4OGgwQTEuMTA4LDEuMTA4LDAsMCwwLDcuNDcyLjc0M0wuNzUzLjAwNUEuNjU1LjY1NSwwLDAsMCwuMDA1Ljc2NmgwQTEuMTA4LDEuMTA4LDAsMCwwLC45MzcsMS43MTFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjY3MyAwKSByb3RhdGUoNDMpIiBmaWxsPSIjMTcyMTRkIi8+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };